module.exports = __webpack_public_path__ + "img/iconfont.aa3f8da.svg";